// clube-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "\"Clube Certo\"": "\"Club Correcto\"",
    "\"Pagamento via Pix\"": "\"Pago vía Pix\"",
    "\"Regras via Clube de Vantagens\"": "\"Reglas vía Club de Beneficios\"",
    "% atingiriam": "% alcanzarían",
    ", mas não poderá criar grupos adicionais enquanto esta regra estiver ativa.": ", pero no podrá crear grupos adicionales mientras esta regla esté activa.",
    ". Cadastre a roleta primeiro em Clube de Vantagens → Roletas.": ". Registre la ruleta primero en Club de Beneficios → Ruletas.",
    "A cada": "Cada",
    "A regra": "La regla",
    "Adicionar Locais de Resgate": "Agregar Lugares de Canje",
    "Adicionar Produto": "Agregar Producto",
    "Adicionar Regra": "Agregar Regla",
    "Alcance Estimado": "Alcance Estimado",
    "Analisando abastecimentos de": "Analizando cargas de combustible de",
    "Analisando o alcance combinado de todas as regras nos últimos": "Analizando el alcance combinado de todas las reglas en los últimos",
    "Apenas bolões em rascunho ou ativos podem receber novas recompensas de palpite.": "Solo las quinielas en borrador o activas pueden recibir nuevas recompensas de pronóstico.",
    "Apenas roletas em rascunho ou ativas podem receber novos giros.": "Solo las ruletas en borrador o activas pueden recibir nuevos giros.",
    "Apenas sorteios em andamento com as regras no Clube de Vantagens.": "Solo sorteos en curso con las reglas en el Club de Beneficios.",
    "Aplicar a Todos": "Aplicar a Todos",
    "Aplicar valores em todos os locais": "Aplicar valores en todos los lugares",
    "Auto": "Auto",
    "Automático": "Automático",
    "Basta atender": "Basta con cumplir",
    "Bolão selecionado:": "Quiniela seleccionada:",
    "Bolão vinculado": "Quiniela vinculada",
    "Brinde disponível para todos os clientes": "Premio disponible para todos los clientes",
    "CPF não disponível": "CPF no disponible",
    "Cadastrar Brinde": "Registrar Premio",
    "Carregando descontos...": "Cargando descuentos...",
    "Cliente (CPF)": "Cliente (CPF)",
    "Cliente paga este valor via Pix para adquirir as recompensas do brinde": "El cliente paga este valor vía Pix para adquirir las recompensas del premio",
    "Cliente paga estes pontos para receber os números da sorte do brinde": "El cliente paga estos puntos para recibir los números de la suerte del premio",
    "Clique em \"Adicionar Regra\" abaixo.": "Haga clic en \"Agregar Regla\" abajo.",
    "Clique no botão abaixo para adicionar locais de resgate": "Haga clic en el botón de abajo para agregar lugares de canje",
    "Clique no botão abaixo para adicionar o primeiro produto": "Haga clic en el botón de abajo para agregar el primer producto",
    "Combustíveis disponíveis neste desconto:": "Combustibles disponibles en este descuento:",
    "Combustível:": "Combustible:",
    "Concedido em:": "Otorgado el:",
    "Configuração de Integração": "Configuración de Integración",
    "Configuração de Partner Value por Produto": "Configuración de Partner Value por Producto",
    "Configure onde o brinde pode ser resgatado e o valor que cada parceiro receberá por produto.": "Configure dónde se puede canjear el premio y el valor que cada socio recibirá por producto.",
    "Código RTI": "Código RTI",
    "Código automático do catálogo de produtos": "Código automático del catálogo de productos",
    "Código de integração RTI": "Código de integración RTI",
    "Código de integração com sistema RTI": "Código de integración con el sistema RTI",
    "Data e Hora da Conquista": "Fecha y Hora del Logro",
    "Demais": "Demás",
    "Desconto (%)": "Descuento (%)",
    "Desconto Vinculado": "Descuento Vinculado",
    "Digitação": "Digitación",
    "Divulgação": "Difusión",
    "EVO": "EVO",
    "Entregue ao cliente que acertar o placar exato — processado manualmente no painel do bolão.": "Se entrega al cliente que acierte el marcador exacto — se procesa manualmente en el panel de la quiniela.",
    "Envio da notificação de criação": "Envío de la notificación de creación",
    "Esta recompensa dá ao cliente": "Esta recompensa le da al cliente",
    "Esta regra": "Esta regla",
    "Este brinde não possui restrições de segmentação por tags ou grupos de clientes, portanto está disponível para todos os clientes da rede.": "Este premio no tiene restricciones de segmentación por etiquetas o grupos de clientes, por lo que está disponible para todos los clientes de la red.",
    "Formatos aceitos: PNG, JPG, GIF": "Formatos aceptados: PNG, JPG, GIF",
    "GPS obrigatório": "GPS obligatorio",
    "Giros por conquista": "Giros por logro",
    "ID do Serviço Trevo": "ID del Servicio Trevo",
    "ID do serviço no Top Banho (Rede Trevo)": "ID del servicio en Top Banho (Rede Trevo)",
    "Imagem do Produto": "Imagen del Producto",
    "Imediatamente após a criação": "Inmediatamente después de la creación",
    "Integração EVO ativa para este produto": "Integración EVO activa para este producto",
    "Já adicionado": "Ya agregado",
    "Limite Acumulado:": "Límite Acumulado:",
    "Limite de conquista": "Límite de logro",
    "Limites e Validade": "Límites y Vigencia",
    "Locais de Resgate": "Lugares de Canje",
    "Locais de Resgate por Produto": "Lugares de Canje por Producto",
    "Locais de troca": "Lugares de canje",
    "Manual do Clube": "Manual del Club",
    "Manual do Clube de Vantagens": "Manual del Club de Beneficios",
    "Mínimo 1. É a quantidade concedida a cada conquista do brinde.": "Mínimo 1. Es la cantidad otorgada en cada logro del premio.",
    "Nenhum cliente encontrado com a segmentação definida para este brinde": "No se encontraron clientes con la segmentación definida para este premio",
    "Nenhum cliente encontrado para os postos e período selecionados.": "No se encontraron clientes para las estaciones y el período seleccionados.",
    "Nenhum combustível configurado neste desconto.": "Ningún combustible configurado en este descuento.",
    "Nenhum desconto do tipo Recompensa cadastrado": "Ningún descuento del tipo Recompensa registrado",
    "Nenhum disparo gerado ainda.": "Aún no se generó ningún envío.",
    "Nenhum local adicionado": "Ningún lugar agregado",
    "Nenhum produto adicionado": "Ningún producto agregado",
    "Nenhum sorteio disponível. Só aparecem aqui os sorteios em andamento criados com a opção": "Ningún sorteo disponible. Aquí solo aparecen los sorteos en curso creados con la opción",
    "Nenhuma conquista registrada para este brinde": "Ningún logro registrado para este premio",
    "Nenhuma notificação configurada para este brinde": "Ninguna notificación configurada para este premio",
    "Nenhuma regra ainda.": "Todavía no hay reglas.",
    "Nenhuma regra simulável encontrada. Apenas regras de abastecimento podem ser simuladas.": "No se encontró ninguna regla simulable. Solo se pueden simular reglas de carga de combustible.",
    "Nenhuma roleta disponível. Só aparecem aqui as roletas em": "Ninguna ruleta disponible. Aquí solo aparecen las ruletas en",
    "Nome do Produto": "Nombre del Producto",
    "Nome, código ou código de divulgação": "Nombre, código o código de difusión",
    "O cliente poderá escolher qualquer combustível acima no momento do abastecimento.": "El cliente podrá elegir cualquier combustible de los anteriores en el momento de la carga de combustible.",
    "Obrigatório": "Obligatorio",
    "Para criar um gift com desconto no combustível, você precisa primeiro cadastrar um desconto do tipo \"Recompensa\".": "Para crear un gift con descuento en el combustible, primero debe registrar un descuento del tipo \"Recompensa\".",
    "Percentual de Desconto (%)": "Porcentaje de Descuento (%)",
    "Percentual de desconto": "Porcentaje de descuento",
    "Período de Verificação:": "Período de Verificación:",
    "Período do limite": "Período del límite",
    "Postos onde o desconto pode ser usado:": "Estaciones donde se puede usar el descuento:",
    "Preview do produto": "Vista previa del producto",
    "Produto #": "Producto #",
    "Produto Selecionado:": "Producto Seleccionado:",
    "Produtos do Brinde": "Productos del Premio",
    "Produtos:": "Productos:",
    "Push Notification:": "Notificación push:",
    "QR Code": "QR Code",
    "QUALQUER UMA": "CUALQUIERA",
    "Quantidade:": "Cantidad:",
    "Quantos números da sorte esta recompensa dá": "Cuántos números de la suerte da esta recompensa",
    "RTI": "RTI",
    "Regra Exclusiva: Clube Certo": "Regla Exclusiva: Club Correcto",
    "Regra Exclusiva: Pagamento Pix": "Regla Exclusiva: Pago con Pix",
    "Regras do tipo": "Reglas del tipo",
    "Roleta selecionada:": "Ruleta seleccionada:",
    "Roleta vinculada": "Ruleta vinculada",
    "SMS:": "SMS:",
    "Segmentação de Clientes:": "Segmentación de Clientes:",
    "Selecione o Produto": "Seleccione el Producto",
    "Selecione o local": "Seleccione el lugar",
    "Selecione o tipo de integração para este produto (opcional)": "Seleccione el tipo de integración para este producto (opcional)",
    "Selecione o tipo de produto": "Seleccione el tipo de producto",
    "Selecione os produtos de venda relacionados": "Seleccione los productos de venta relacionados",
    "Selecione um local onde o brinde pode ser resgatado": "Seleccione un lugar donde se pueda canjear el premio",
    "Selecione um produto existente do catálogo": "Seleccione un producto existente del catálogo",
    "Sem notificação de criação": "Sin notificación de creación",
    "Será aplicado apenas em locais manuais": "Se aplicará solo en lugares manuales",
    "Simulação de Alcance": "Simulación de Alcance",
    "Sorteio selecionado:": "Sorteo seleccionado:",
    "Sorteio vinculado": "Sorteo vinculado",
    "Status do disparo": "Estado del envío",
    "Teixeira Pinto": "Teixeira Pinto",
    "Tipo de Integração": "Tipo de Integración",
    "Tipo de recompensa": "Tipo de recompensa",
    "Tipo de regra": "Tipo de regla",
    "Tipo de validade": "Tipo de vigencia",
    "Todos os combustíveis": "Todos los combustibles",
    "Top Banho (Rede Trevo)": "Top Banho (Rede Trevo)",
    "Valor do parceiro": "Valor del socio",
    "Valor parceiro": "Valor socio",
    "Vigência": "Vigencia",
    "Você ainda pode adicionar outras regras no mesmo grupo usando": "Usted todavía puede agregar otras reglas en el mismo grupo usando",
    "Válido até": "Válido hasta",
    "Válido por": "Válido por",
    "as condições": "las condiciones",
    "atingiriam": "alcanzarían",
    "ativas": "activas",
    "brinde criado com sucesso": "premio creado con éxito",
    "cliente": "cliente",
    "com outras regras de abastecimento. Não é possível adicionar mais grupos ou regras.": "con otras reglas de carga de combustible. No es posible agregar más grupos ni reglas.",
    "combustível(is) configurado(s)": "combustible(s) configurado(s)",
    "compra o brinde pagando via Pix": "compra el premio pagando vía Pix",
    "de um sorteio que você já cadastrou. Cada vez que o cliente cumprir a regra deste brinde, ele recebe a quantidade de números configurada aqui — não um cupom.": "de un sorteo que usted ya registró. Cada vez que el cliente cumpla la regla de este premio, recibe la cantidad de números configurada aquí — no un cupón.",
    "destas regras": "de estas reglas",
    "em um bolão que você já cadastrou. Quando o cliente cumprir a regra deste brinde, ele ganha o ticket de palpite — não um cupom. O cupom de verdade vem se ele acertar o placar.": "en una quiniela que usted ya registró. Cuando el cliente cumpla la regla de este premio, gana el ticket de pronóstico — no un cupón. El cupón real llega si acierta el marcador.",
    "giros na Roleta da Sorte": "giros en la Ruleta de la Suerte",
    "ligada.": "activada.",
    "locais": "lugares",
    "não pode ser combinada": "no se puede combinar",
    "não pode ser combinada com outros grupos usando E TAMBÉM": "no se puede combinar con otros grupos usando Y TAMBIÉN",
    "não podem ser simuladas com base em abastecimentos": "no se pueden simular en función de las cargas de combustible",
    "números da sorte": "números de la suerte",
    "o direito de palpitar": "el derecho a pronosticar",
    "ou": "o",
    "pontos": "puntos",
    "que abasteceram · últimos": "que cargaron combustible · últimos",
    "que você já cadastrou. Cada vez que o cliente cumprir a regra deste brinde, ele recebe a quantidade de giros configurada aqui — não um cupom. O prêmio de verdade sai quando ele girar.": "que usted ya registró. Cada vez que el cliente cumpla la regla de este premio, recibe la cantidad de giros configurada aquí — no un cupón. El premio real sale cuando gire.",
    "rascunho": "borrador",
    "teriam atingido esta regra": "habrían alcanzado esta regla",
    "todas": "todas",
    "é uma regra exclusiva e": "es una regla exclusiva y",
    "é uma regra exclusiva. O cliente": "es una regla exclusiva. El cliente",
    "→ Cadastrar novo desconto": "→ Registrar nuevo descuento",
};

export default catalogo;
